import { getElement, resetForm } from "../../../../helpers";

let FormVideo;

export const storeVideo = () => {
    FormVideo = document.querySelector("#formVideo");

    FormVideo.elements.save.addEventListener("click", () => {
        if (FormVideo.reportValidity()) {
            FormVideo.submit();
        }
    });
};

export const create = (url, title) => {
    resetForm("formVideo", title, url);
};

export const edit = (url, title, data) => {
    data = JSON.parse(atob(data));
    resetForm("formVideo", title, url);
    FormVideo.elements.name.value = data.name;
    FormVideo.elements.url.value = data.url;
    FormVideo.elements.description.value = data.description;
    const Img = getElement("[is=input-image]", FormVideo)?.firstElementChild
        .firstElementChild;
    Img.src = "/images/videos/" + data.image;
};
